import { render, staticRenderFns } from "./NewSubjectDialog.vue?vue&type=template&id=42d2e8b8&scoped=true&"
import script from "@/views/Subjects/Dialogs/NewSubjectDialog.ts?vue&type=script&lang=ts&"
export * from "@/views/Subjects/Dialogs/NewSubjectDialog.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Subjects/Dialogs/new-subject-dialog.scss?vue&type=style&index=0&id=42d2e8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d2e8b8",
  null
  
)

export default component.exports